import { useState } from 'react'
import useSWRImmutable from 'swr/immutable'
import { fetcher } from './fetcher'

export function useFilter(
  categorySet,
  modelSet,
  initialData,
  restUrl,
  page,
  revalidateOnMount = false,
  specificModel = null,
  specificVariant = null,
  isLeasing = false,
  show_type = 'accessory_shop'
) {
  const currentArgs = [
    restUrl,
    {
      method: 'POST',
      body: JSON.stringify({
        categories_ids: Array.from(categorySet),
        model_ids: Array.from(modelSet),
        specific_model: specificModel,
        specific_variant: specificVariant,
        page: page,
        is_leasing: isLeasing,
        show_type: show_type
      }),
      headers: {
        'Content-Type': 'application/json'
      }
    }
  ]
  const [initialArgs] = useState(() => JSON.stringify(currentArgs))
  const { data, error, isValidating } = useSWRImmutable(currentArgs, fetcher, {
    revalidateOnMount: revalidateOnMount
  })
  const loading = data == null
  const isFirst = initialArgs === JSON.stringify(currentArgs)
  return {
    data: loading ? (isFirst ? initialData : data) : data,
    loading: isValidating,
    error
  }
}
